import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { trackPageViewFromTransition } from 'sh-www/utils/datalayer';

import { GET_TOKEN, GET_EMAIL } from 'sh-www/controllers/reset-password';

class ResetPasswordRoute extends Route {
  @service router;
  @service session;

  activate(transition) {
    super.activate(...arguments);
    trackPageViewFromTransition(this, transition, '/reset-password/');
  }

  resetController(controller, isExiting) {
    super.resetController(...arguments);

    if (isExiting) {
      controller.setProperties({
        [GET_TOKEN]: null,
        [GET_EMAIL]: null,
      });
    }
  }
}

export default ResetPasswordRoute;
